import React, { useEffect, useState } from 'react';

import './ErrorPage.css';

import iconClose from './../../image/close.svg';

const ErrorPage = ({ setCurrentPage, setIsShowError, errorStatus }) => {
    const [errorTitle, setErrorTitle] = useState('');
    const [errorText, setErrorText] = useState('');

    useEffect(() => {
        if (errorStatus === 1) {
            setErrorTitle('Ошибка');
            setErrorText('Проверьте правильность заполнения данных');
        }

        if (errorStatus === 2) {
            setErrorTitle('Ошибка');
            setErrorText('Превышено максимальное количество бронирования');
        }

        if (errorStatus === 3) {
            setErrorTitle('Ошибка');
            setErrorText('Ошибка вызова персонала');
        }

        if (errorStatus === 4) {
            setErrorTitle('Ошибка');
            setErrorText('Ожидайте');
        }

        if (errorStatus === 5) {
            setErrorTitle('!');
            setErrorText('Ошибка');
        }
    }, [errorStatus]);

    const handleOKClick = () => {
        if (errorStatus === 1 || errorStatus === 2 || errorStatus === 3) {
            setCurrentPage('MainPage');
        }
        setIsShowError(false);
    };

    return (
        <div className='error__wrapper'>
            <div className='error__message'>
                <div className='error__close' onClick={handleOKClick}>
                    <img src={iconClose} alt='Close' />
                </div>
                <h1 className='error__title'>{errorTitle}</h1>
                <p className='error__message_text'>{errorText}</p>
                <button className='error__btn' onClick={handleOKClick}>
                    OK
                </button>
            </div>
        </div>
    );
};

export default ErrorPage;
